// Authoritative German master version – generated verbatim from Soul_Radar_Datenschutzerklaerung_2026-09-13.docx. Do not edit by hand.
export const PRIVACY_DE = {
 "title": "Datenschutzerklärung",
 "subtitle": "Stand: 13. September 2026",
 "blocks": [
  {
   "h": "1. Verantwortlicher"
  },
  {
   "p": "Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:"
  },
  {
   "p": "Soul Radar – Your Soul Event Finder"
  },
  {
   "p": "Tim-Niklas Kubach"
  },
  {
   "p": "Lugbank 6"
  },
  {
   "p": "96049 Bamberg"
  },
  {
   "p": "Deutschland"
  },
  {
   "p": "E-Mail: info@soulradar.net"
  },
  {
   "p": "Diese Datenschutzerklärung informiert darüber, welche personenbezogenen Daten bei der Nutzung von Soul Radar (soulradar.net) verarbeitet werden, zu welchen Zwecken dies geschieht und welche Rechte betroffene Personen haben."
  },
  {
   "h": "2. Allgemeines zur Datenverarbeitung"
  },
  {
   "p": "Soul Radar ist eine Plattform zur Suche, Veröffentlichung und Verwaltung von Soul-Veranstaltungen sowie zur Vernetzung von Nutzern, DJs und Veranstaltern."
  },
  {
   "p": "Je nach Nutzung von Soul Radar können insbesondere folgende Daten verarbeitet werden: Name bzw. Profilname, E-Mail-Adresse, Authentifizierungs- und Sitzungsdaten, freiwillige Profilangaben, Profilbilder, Veranstaltungsdaten, Teilnahme- und Favoritendaten, Follower-/Following-Beziehungen, Nachrichten, freiwillig bereitgestellte Standortdaten sowie technische Nutzungs- und Protokolldaten."
  },
  {
   "p": "Die Verarbeitung erfolgt abhängig vom jeweiligen Vorgang insbesondere auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO zur Bereitstellung der gewünschten Funktionen und Art. 6 Abs. 1 lit. f DSGVO zur Gewährleistung eines sicheren und funktionsfähigen Betriebs. Soweit eine Verarbeitung auf einer Einwilligung beruht, ist Art. 6 Abs. 1 lit. a DSGVO die Rechtsgrundlage."
  },
  {
   "h": "3. Hosting und Emergent"
  },
  {
   "p": "Soul Radar wird über die Plattform Emergent betrieben."
  },
  {
   "p": "Auftragsverarbeiter ist:"
  },
  {
   "p": "Emergent Labs Inc."
  },
  {
   "p": "2380 Via Espada"
  },
  {
   "p": "Pleasanton, CA 94566"
  },
  {
   "p": "USA"
  },
  {
   "p": "E-Mail: privacy@emergent.sh"
  },
  {
   "p": "Nach der mit Emergent bestehenden Datenverarbeitungsvereinbarung handelt Soul Radar hinsichtlich der Daten seiner Nutzer als Verantwortlicher und Emergent als Auftragsverarbeiter. Zu den von Emergent im Auftrag verarbeiteten Daten gehören ausdrücklich auch personenbezogene Daten in den für die Anwendung bereitgestellten Datenbanken und Speichern."
  },
  {
   "p": "Emergent setzt zur Bereitstellung seiner Leistungen Unterauftragsverarbeiter ein. Hierzu können insbesondere Anbieter für Cloud-Hosting, Object Storage, E-Mail-Versand und Authentifizierung gehören."
  },
  {
   "p": "Die Verarbeitung durch Emergent und seine Unterauftragsverarbeiter kann in der EU, den USA und Indien erfolgen."
  },
  {
   "p": "Soweit Daten in ein Drittland ohne Angemessenheitsbeschluss übermittelt werden, sieht die Datenverarbeitungsvereinbarung insbesondere die Standardvertragsklauseln der Europäischen Kommission gemäß Art. 46 DSGVO als Übermittlungsgrundlage vor."
  },
  {
   "p": "Emergent verpflichtet sich, personenbezogene Kundendaten nicht zum Training, Retraining oder Fine-Tuning von KI-Modellen zu verwenden und dies auch den eingesetzten KI-Unterauftragsverarbeitern vertraglich zu untersagen."
  },
  {
   "h": "4. Technische Zugriffs- und Protokolldaten"
  },
  {
   "p": "Beim Aufruf von Soul Radar werden technisch erforderliche Daten verarbeitet. Hierzu können insbesondere IP-Adresse, Zeitpunkt und Art des Zugriffs, aufgerufene Ressourcen, Browser- und Geräteinformationen sowie Fehler- und Diagnosedaten gehören."
  },
  {
   "p": "Die Verarbeitung dient der Auslieferung der Website, dem sicheren und stabilen Betrieb sowie der Erkennung und Abwehr von Missbrauch und technischen Störungen."
  },
  {
   "p": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse besteht im sicheren und funktionsfähigen Betrieb von Soul Radar."
  },
  {
   "p": "Präzise Standortkoordinaten der Near-Me-Funktion werden in den von Soul Radar kontrollierten Access-Logs nicht im Klartext protokolliert."
  },
  {
   "p": "Bestimmte plattformseitige Service- und Logdaten verarbeitet Emergent nach seiner Datenverarbeitungsvereinbarung für eigene Zwecke, insbesondere Betrieb und Sicherheit sowie Betrugs- und Missbrauchsprävention, als eigener Verantwortlicher."
  },
  {
   "p": "Für einzelne von Emergent auf Plattformebene geführte Infrastruktur-, Ingress- und Systemprotokolle liegen Soul Radar keine konkreten Löschfristen vor. Diese werden nach den Vorgaben des Plattformbetreibers verarbeitet und gelöscht, sobald sie für die jeweiligen Zwecke bzw. bestehende Aufbewahrungspflichten nicht mehr erforderlich sind."
  },
  {
   "h": "5. Registrierung und Benutzerkonto"
  },
  {
   "p": "Bestimmte Funktionen von Soul Radar setzen ein Benutzerkonto voraus."
  },
  {
   "p": "Bei der Registrierung werden insbesondere Name, E-Mail-Adresse, Authentifizierungsdaten sowie die vom Nutzer gewählten Profil- und Kontoeinstellungen verarbeitet."
  },
  {
   "p": "Passwörter werden nicht im Klartext gespeichert, sondern mittels eines kryptografischen Hashverfahrens (bcrypt) geschützt."
  },
  {
   "p": "Die Verarbeitung erfolgt zur Einrichtung und Bereitstellung des Benutzerkontos auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "p": "Soul Radar ist für registrierte Nutzer ab 16 Jahren vorgesehen. Bei der Registrierung muss bestätigt werden, dass das Mindestalter von 16 Jahren erreicht ist. Dies gilt auch bei der erstmaligen Einrichtung eines Kontos über Google Login. Ein Geburtsdatum wird hierfür nicht erhoben."
  },
  {
   "h": "6. Google Login"
  },
  {
   "p": "Alternativ zur regulären Registrierung kann ein Benutzerkonto über Google eingerichtet bzw. die Anmeldung über Google vorgenommen werden."
  },
  {
   "p": "Dabei erhält Soul Radar insbesondere Name, E-Mail-Adresse, Profilbild-URL und die Information über die erfolgreiche Authentifizierung. Soul Radar speichert nach dem derzeitigen technischen Stand keine Google-Access- oder Refresh-Tokens."
  },
  {
   "p": "Im Zusammenhang mit der Google-Authentifizierung können personenbezogene Daten an Google und in die USA übermittelt werden."
  },
  {
   "p": "Die Nutzung des Google-Logins ist freiwillig. Alternativ steht die reguläre Anmeldung zur Verfügung. Rechtsgrundlage für die Verarbeitung durch Soul Radar ist Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "h": "7. Öffentliche Profile"
  },
  {
   "p": "Soul-Radar-Profile können grundsätzlich auch ohne Anmeldung öffentlich aufgerufen werden."
  },
  {
   "p": "Je nach freiwilligen Angaben und Nutzung können dort insbesondere sichtbar sein:"
  },
  {
   "ul": [
    "Profilname und Profilbild",
    "freiwillig angegebener Ort",
    "DJ- bzw. Organizer-Kennzeichnung",
    "Biografie und weitere freiwillige Profilangaben",
    "Lieblingssong und Lieblingsveranstaltung",
    "verlinkte Social-Media-Profile",
    "kommende und vergangene Veranstaltungen",
    "Teilnahme-, DJ- und Organizer-Historie",
    "Follower- und Following-Zahlen"
   ]
  },
  {
   "p": "Follower- und Following-Angaben können angeklickt werden, sodass sichtbar ist, welche Profile dahinterstehen."
  },
  {
   "p": "Nutzer sollten deshalb in ihrem öffentlichen Profil nur Informationen angeben, die sie öffentlich zugänglich machen möchten."
  },
  {
   "p": "Öffentlich zugängliche Informationen können grundsätzlich auch von Suchmaschinen erfasst werden, soweit die jeweilige Seite nicht technisch von einer Indexierung ausgeschlossen ist."
  },
  {
   "p": "Rechtsgrundlage für die Bereitstellung der vom Nutzer gewählten Profil- und Community-Funktionen ist Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "h": "8. „I'm Going“ und Veranstaltungshistorie"
  },
  {
   "p": "Angemeldete Nutzer können mit „I'm Going“ angeben, dass sie eine Veranstaltung besuchen möchten."
  },
  {
   "p": "Die Anzahl der Zusagen kann öffentlich angezeigt werden. Die konkrete Liste der teilnehmenden Nutzer ist nur für angemeldete Nutzer zugänglich."
  },
  {
   "p": "Die Veranstaltungshistorie eines Nutzers wird aus seinen „I'm Going“-Angaben abgeleitet. Nach Ende einer Veranstaltung kann diese daher als besuchte Veranstaltung im öffentlichen Profil erscheinen."
  },
  {
   "p": "Wird eine „I'm Going“-Angabe zurückgenommen, wird die entsprechende Verbindung entfernt und die Veranstaltung nicht mehr aufgrund dieser Angabe in der persönlichen Historie berücksichtigt."
  },
  {
   "p": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "h": "9. DJ- und Organizer-Zuordnungen"
  },
  {
   "p": "Soul Radar kann anzeigen, bei welchen Veranstaltungen ein Nutzer als DJ oder Veranstalter geführt wurde."
  },
  {
   "p": "DJ-Zuordnungen können sowohl mit einem Soul-Radar-Profil verknüpft sein als auch lediglich als freier DJ-/Artist-Name in einer Veranstaltung erscheinen."
  },
  {
   "p": "Veranstaltungen, die von Soul Radar selbst redaktionell eingestellt werden, werden dem hierfür tätigen Benutzerkonto nicht als persönlich organisierte Veranstaltungen zugerechnet."
  },
  {
   "p": "Namen von DJs, Artists und Veranstaltern können als Bestandteil historischer Veranstaltungsinformationen auch nach Ende einer Veranstaltung erhalten bleiben."
  },
  {
   "p": "Rechtsgrundlage ist abhängig von der konkreten Zuordnung Art. 6 Abs. 1 lit. b oder lit. f DSGVO. Das berechtigte Interesse besteht insbesondere in der Bereitstellung zutreffender Veranstaltungsinformationen und eines nachvollziehbaren Veranstaltungsarchivs."
  },
  {
   "h": "10. Folgen und Blockieren"
  },
  {
   "p": "Angemeldete Nutzer können anderen Nutzern, DJs und Veranstaltern folgen und Nutzer blockieren."
  },
  {
   "p": "Hierfür werden die entsprechenden Beziehungen zwischen Benutzerkonten gespeichert. Follower- und Following-Beziehungen können im Rahmen der Community-Funktionen für andere Nutzer sichtbar sein. Blockierungen sind nicht öffentlich sichtbar."
  },
  {
   "p": "Bei Löschung eines Benutzerkontos werden die damit verbundenen Follow- und Block-Beziehungen entfernt."
  },
  {
   "p": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "h": "11. Gespeicherte Veranstaltungen"
  },
  {
   "p": "Angemeldete Nutzer können Veranstaltungen speichern bzw. als Favoriten markieren. Hierzu wird die Verbindung zwischen dem Benutzerkonto und der jeweiligen Veranstaltung gespeichert."
  },
  {
   "p": "Bei Löschung des Benutzerkontos werden diese persönlichen Zuordnungen gelöscht."
  },
  {
   "p": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "h": "12. Veranstaltungen und Veranstaltungsarchiv"
  },
  {
   "p": "Veranstalter können Veranstaltungen bei Soul Radar einreichen und verwalten. Dabei können insbesondere Veranstaltungstitel, Datum und Uhrzeit, Veranstaltungsort und Adresse, Beschreibung, Genres, Veranstaltungstyp, Eintritts- und Ticketinformationen, externe Links, Venue-Informationen, Namen von DJs und Artists sowie Flyer und weitere Bilder verarbeitet werden."
  },
  {
   "p": "Soul Radar kann Veranstaltungen außerdem selbst redaktionell erfassen. Eine solche Erfassung bedeutet nicht, dass Soul Radar oder der Benutzer, der die Daten eingetragen hat, Veranstalter der Veranstaltung ist."
  },
  {
   "p": "Veröffentlichte Veranstaltungen können nach ihrem Ende im öffentlichen Veranstaltungsarchiv verbleiben. Dies dient der Dokumentation vergangener Veranstaltungen sowie den darauf aufbauenden Historien- und Community-Funktionen."
  },
  {
   "p": "Rechtsgrundlage für die Verarbeitung durch Veranstalter ist insbesondere Art. 6 Abs. 1 lit. b DSGVO. Für die redaktionelle Bereitstellung und Archivierung öffentlich beworbener Veranstaltungsinformationen stützen wir uns insbesondere auf Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse besteht im Betrieb eines Informations- und Veranstaltungsarchivs für die Soul-Szene."
  },
  {
   "h": "13. Bilder, Flyer und Dateispeicher"
  },
  {
   "p": "Profilbilder, Event-Flyer und weitere hochgeladene Bilder werden über den für Soul Radar bereitgestellten Dateispeicher von Emergent verarbeitet."
  },
  {
   "p": "Veranstaltungsbilder und Flyer sind entsprechend ihrer Funktion öffentlich abrufbar."
  },
  {
   "p": "Nutzer dürfen nur Inhalte hochladen, zu deren Verwendung und Veröffentlichung sie berechtigt sind. Sollten Personen der Auffassung sein, dass ein Bild oder andere personenbezogene Inhalte unberechtigt veröffentlicht wurden, können sie sich an info@soulradar.net wenden."
  },
  {
   "p": "Bei der Löschung eines Benutzerkontos wird das dazugehörige Profilbild aus dem von Soul Radar genutzten Dateispeicher gelöscht bzw. für den regulären Zugriff unzugänglich gemacht. Veranstaltungsflyer bleiben erhalten, wenn die zugehörige Veranstaltung im Archiv verbleibt."
  },
  {
   "h": "14. Direktnachrichten"
  },
  {
   "p": "Angemeldete Nutzer können über Soul Radar Direktnachrichten austauschen."
  },
  {
   "p": "Dabei werden insbesondere Absender, Empfänger, Nachrichteninhalt, Zeitstempel und gegebenenfalls ein Veranstaltungsbezug verarbeitet."
  },
  {
   "p": "Wenn ein Nutzer eine Nachricht aus seiner Ansicht löscht, wird sie für diesen Nutzer ausgeblendet. Sie kann für den anderen Gesprächsteilnehmer weiterhin verfügbar bleiben."
  },
  {
   "p": "Wird das Benutzerkonto eines Absenders gelöscht, können bereits versandte Nachrichten für den anderen Gesprächsteilnehmer erhalten bleiben, damit dessen bestehende Kommunikation nicht nachträglich verändert wird. Die Verbindung zum gelöschten Benutzerkonto wird dabei entfernt. Der Absender wird anschließend als „Gelöschter Nutzer“ bzw. „Deleted user“ angezeigt. Profilbild, Profillink, Standort und andere Profildaten des gelöschten Kontos werden darüber nicht mehr bereitgestellt."
  },
  {
   "p": "Rechtsgrundlage für die Nachrichtenfunktion ist Art. 6 Abs. 1 lit. b DSGVO. Die begrenzte Aufbewahrung bereits empfangener Nachrichten nach Kontolöschung kann auf Art. 6 Abs. 1 lit. f DSGVO beruhen. Das berechtigte Interesse besteht darin, die Kommunikationshistorie des verbleibenden Gesprächspartners nicht nachträglich zu verfälschen."
  },
  {
   "h": "15. Standortfunktion „Near Me“"
  },
  {
   "p": "Soul Radar bietet eine freiwillige Umkreissuche."
  },
  {
   "p": "Auf den Standort des Endgeräts wird nur zugegriffen, wenn der Nutzer die Funktion aktiv aufruft und die Standortfreigabe über Browser bzw. Endgerät erteilt."
  },
  {
   "p": "Die aktuellen geografischen Koordinaten werden zur Ermittlung von Veranstaltungen im gewünschten Umkreis vorübergehend an das Soul-Radar-Backend übertragen."
  },
  {
   "p": "Die präzisen Gerätekoordinaten werden nicht dauerhaft in der Soul-Radar-Datenbank gespeichert. Soul Radar erstellt keine Standort-Historie. In den von Soul Radar kontrollierten Access-Logs werden übermittelte Längen- und Breitengrade redigiert."
  },
  {
   "p": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, da die Verarbeitung ausschließlich zur Bereitstellung der vom Nutzer aktiv angeforderten Umkreissuche erfolgt."
  },
  {
   "h": "16. Ortsangabe im Profil"
  },
  {
   "p": "Unabhängig von „Near Me“ kann ein Nutzer freiwillig einen Ort in seinem Profil angeben."
  },
  {
   "p": "Dieser Profilort wird gespeichert und kann öffentlich angezeigt werden. Er ist von den präzisen Standortkoordinaten des Endgeräts zu unterscheiden."
  },
  {
   "p": "Die Angabe kann vom Nutzer geändert oder entfernt werden."
  },
  {
   "h": "17. OpenStreetMap"
  },
  {
   "p": "Für die Kartendarstellung verwendet Soul Radar Kartenmaterial von OpenStreetMap."
  },
  {
   "p": "Beim Laden der Kartenansicht werden Kartenkacheln unmittelbar von der Infrastruktur der OpenStreetMap Foundation abgerufen. Dabei werden technisch insbesondere die IP-Adresse, Browserinformationen und der angeforderte Kartenausschnitt verarbeitet."
  },
  {
   "p": "Anbieter:"
  },
  {
   "p": "OpenStreetMap Foundation"
  },
  {
   "p": "St John's Innovation Centre"
  },
  {
   "p": "Cowley Road"
  },
  {
   "p": "Cambridge"
  },
  {
   "p": "CB4 0WS"
  },
  {
   "p": "United Kingdom"
  },
  {
   "p": "Die Kartendaten werden zur Bereitstellung der vom Nutzer aufgerufenen Kartenfunktion verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO."
  },
  {
   "p": "Datenschutzinformationen: https://osmfoundation.org/wiki/Privacy_Policy"
  },
  {
   "h": "18. Nominatim-Geocoding"
  },
  {
   "p": "Zur Umwandlung von Orts- und Adressangaben in geografische Koordinaten verwendet Soul Radar den von der OpenStreetMap Foundation bereitgestellten Dienst Nominatim."
  },
  {
   "p": "Die Anfrage erfolgt über das Soul-Radar-Backend. Die IP-Adresse des Nutzers wird daher nicht unmittelbar als Bestandteil dieser Anfrage von dessen Browser an Nominatim übertragen. Verarbeitet wird insbesondere die zu geocodierende Orts- bzw. Adressangabe."
  },
  {
   "p": "Geocoding-Ergebnisse können intern zwischengespeichert werden, um wiederholte identische Anfragen zu vermeiden."
  },
  {
   "p": "Nominatim Usage Policy: https://operations.osmfoundation.org/policies/nominatim/"
  },
  {
   "h": "19. E-Mail-Versand"
  },
  {
   "p": "Soul Radar versendet funktionsbezogene E-Mails, insbesondere zur E-Mail-Verifizierung, Passwortzurücksetzung sowie gegebenenfalls im Zusammenhang mit Benutzer-, Support- und Community-Funktionen."
  },
  {
   "p": "Der Versand erfolgt über die von Emergent bereitgestellte E-Mail-Infrastruktur. Nach der Subprocessor-Dokumentation von Emergent wird hierfür unter anderem Amazon Simple Email Service (Amazon SES) eingesetzt."
  },
  {
   "p": "Hierbei können insbesondere E-Mail-Adresse, Name, Betreff, Nachrichteninhalt und technische Zustellinformationen verarbeitet werden."
  },
  {
   "p": "Emergent darf für die Bereitstellung seiner Dienste Unterauftragsverarbeiter einsetzen und bleibt nach seinem DPA für deren datenschutzrechtliche Verpflichtungen verantwortlich."
  },
  {
   "h": "20. Supportanfragen, Meldungen und Moderation"
  },
  {
   "p": "Wenn Nutzer Soul Radar kontaktieren, Supportanfragen stellen oder Inhalte bzw. andere Nutzer melden, werden die zur Bearbeitung erforderlichen Daten verarbeitet. Hierzu können insbesondere Kontaktdaten, Benutzerkennung, Nachrichtentext, Angaben zum betreffenden Inhalt und interne Bearbeitungsinformationen gehören."
  },
  {
   "p": "Geschlossene Supportfälle, Reports sowie Audit- und Moderationsinformationen werden grundsätzlich bis zu 365 Tage aufbewahrt. Einzelne Vorgänge können länger aufbewahrt werden, soweit dies aufgrund eines fortbestehenden Missbrauchs-, Sicherheits- oder Rechtsfalls erforderlich ist."
  },
  {
   "p": "Bei Löschung eines Benutzerkontos werden in verbleibenden Audit- bzw. Moderationsinformationen der Klarname des Nutzers entfernt und die interne Nutzerkennung pseudonymisiert."
  },
  {
   "p": "Rechtsgrundlage ist je nach Vorgang Art. 6 Abs. 1 lit. b oder lit. f DSGVO. Unsere berechtigten Interessen bestehen insbesondere in der Bearbeitung von Anfragen, Moderation, Missbrauchsprävention sowie Sicherheit und Integrität der Plattform."
  },
  {
   "h": "21. Cookies und lokale Browserspeicherung"
  },
  {
   "p": "Soul Radar verwendet Cookies und Browser-Speichertechnologien, soweit diese für Anmeldung, Sicherheit, Sprache, Darstellung oder vom Nutzer gewählte Funktionen erforderlich sind."
  },
  {
   "p": "Hierzu gehören insbesondere das für die angemeldete Sitzung erforderliche Session-Cookie sowie lokale Einträge für Authentifizierung und Einstellungen wie Sprache, Darstellung und Ansichtsmodus."
  },
  {
   "p": "Soweit Speicherung oder Zugriff auf Informationen im Endgerät unbedingt erforderlich sind, um einen vom Nutzer ausdrücklich gewünschten digitalen Dienst bereitzustellen, erfolgt dies nach § 25 Abs. 2 TDDDG ohne vorherige Einwilligung."
  },
  {
   "p": "Soul Radar verwendet derzeit keine eigenen nicht erforderlichen Analyse-, Werbe- oder Tracking-Technologien. Insbesondere werden PostHog und dessen Session Recording auf soulradar.net nicht eingesetzt."
  },
  {
   "p": "Soul Radar verwendet keine personalisierte Werbung und erstellt keine Werbeprofile seiner Nutzer."
  },
  {
   "h": "22. Empfänger personenbezogener Daten"
  },
  {
   "p": "Personenbezogene Daten werden nur weitergegeben, soweit dies für die Bereitstellung von Soul Radar erforderlich ist, eine gesetzliche Verpflichtung besteht oder eine andere Rechtsgrundlage vorliegt."
  },
  {
   "p": "Zu den möglichen Empfängern gehören insbesondere:"
  },
  {
   "ul": [
    "Emergent Labs Inc. als Auftragsverarbeiter für Hosting und Plattformbetrieb,",
    "die von Emergent für die konkret verwendeten Funktionen eingesetzten Unterauftragsverarbeiter, insbesondere Infrastruktur-, Storage- und E-Mail-Dienstleister,",
    "Google bei Nutzung des Google-Logins,",
    "die OpenStreetMap Foundation bei Nutzung von Karten- und Geocoding-Funktionen."
   ]
  },
  {
   "p": "Die allgemeine Subprocessor-Liste von Emergent enthält zahlreiche Anbieter für unterschiedliche Emergent-Produkte und Funktionen. Dies bedeutet nicht, dass sämtliche dort aufgeführten Unternehmen personenbezogene Daten von Soul-Radar-Nutzern erhalten."
  },
  {
   "h": "23. Drittlandübermittlungen"
  },
  {
   "p": "Im Rahmen des Betriebs von Soul Radar kann es zur Verarbeitung personenbezogener Daten außerhalb der Europäischen Union bzw. des Europäischen Wirtschaftsraums kommen."
  },
  {
   "p": "Das Emergent-DPA nennt als Verarbeitungsorte USA, EU und Indien."
  },
  {
   "p": "Soweit für ein Drittland kein Angemessenheitsbeschluss der Europäischen Kommission besteht, sieht die Vereinbarung mit Emergent insbesondere die Standardvertragsklauseln der Europäischen Kommission gemäß Art. 46 DSGVO vor. Für die Beziehung zwischen Soul Radar als Verantwortlichem und Emergent als Auftragsverarbeiter ist dabei grundsätzlich das entsprechende Controller-to-Processor-Modul vorgesehen."
  },
  {
   "h": "24. Kontolöschung und Speicherdauer"
  },
  {
   "p": "Nutzer können ihr Soul-Radar-Konto selbst löschen."
  },
  {
   "p": "Bei der Kontolöschung werden insbesondere das Benutzerkonto und die Profildaten, aktive Sitzungen und E-Mail-Tokens, „I'm Going“-Zuordnungen, Favoriten, Follow- und Block-Beziehungen, Organizer-Profil und nicht mehr erforderliche offene Zuordnungen gelöscht."
  },
  {
   "p": "Das Profilbild wird aus dem von Soul Radar verwendeten Dateispeicher gelöscht bzw. anschließend nicht mehr regulär zugänglich gemacht."
  },
  {
   "p": "Bereits veröffentlichte und archivierte Veranstaltungen werden durch die Löschung eines Benutzerkontos nicht automatisch gelöscht. Stattdessen wird die Verbindung zum Benutzerkonto entfernt. Dies gilt insbesondere deshalb, weil historische Veranstaltungsinformationen Bestandteil des öffentlichen Veranstaltungsarchivs sind. Redaktionell als Soul Radar eingestellte Veranstaltungen bleiben Soul Radar zugeordnet."
  },
  {
   "p": "Bereits versandte Direktnachrichten können für den jeweiligen Gesprächspartner erhalten bleiben; die Verbindung zum gelöschten Benutzerkonto wird dabei entfernt und der Absender als „Gelöschter Nutzer“ angezeigt."
  },
  {
   "p": "Audit-, Moderations-, Support- und Reportdaten können entsprechend den in dieser Datenschutzerklärung genannten Fristen bzw. solange ein konkreter Sicherheits- oder Rechtsgrund besteht aufbewahrt werden."
  },
  {
   "h": "25. Backups"
  },
  {
   "p": "Von der produktiven Datenbank werden durch die von Emergent bereitgestellte Infrastruktur Sicherungskopien erstellt."
  },
  {
   "p": "Nach den derzeit für die eingesetzte Infrastruktur dokumentierten Backup-Zyklen können gelöschte Daten in Sicherungskopien bis zu 12 Monate verbleiben."
  },
  {
   "p": "Diese Sicherungskopien dienen der Ausfallsicherheit und Wiederherstellung und sind nicht Bestandteil des regulären produktiven Zugriffs."
  },
  {
   "p": "Auch das DPA von Emergent sieht vor, dass Daten in routinemäßigen Backups oder Archiven möglicherweise nicht sofort gelöscht werden können. Sie sind in diesem Fall zu isolieren, außer Nutzung zu setzen und bis zur Löschung im regulären Backup-Zyklus vor weiterer Verarbeitung zu schützen."
  },
  {
   "h": "26. Datensicherheit"
  },
  {
   "p": "Soul Radar setzt technische und organisatorische Maßnahmen ein, um personenbezogene Daten vor Verlust, Manipulation und unberechtigtem Zugriff zu schützen."
  },
  {
   "p": "Hierzu gehören insbesondere verschlüsselte Datenübertragung über HTTPS/TLS, kryptografisches Passwort-Hashing, geschützte Session-Cookies, Zugriffsbeschränkungen, CORS-Beschränkungen, Rate-Limiting für sicherheitsrelevante Vorgänge und eine geschützte Verwaltung von Zugangsdaten und Secrets."
  },
  {
   "p": "Emergent verpflichtet sich im DPA zur Umsetzung angemessener technischer und organisatorischer Maßnahmen gemäß Art. 32 DSGVO und gibt an, ISO 27001 sowie SOC 2 Type II zu unterhalten."
  },
  {
   "h": "27. Rechte betroffener Personen"
  },
  {
   "p": "Betroffene Personen haben nach den gesetzlichen Voraussetzungen insbesondere das Recht auf Auskunft gemäß Art. 15 DSGVO, Berichtigung gemäß Art. 16 DSGVO, Löschung gemäß Art. 17 DSGVO, Einschränkung der Verarbeitung gemäß Art. 18 DSGVO, Datenübertragbarkeit gemäß Art. 20 DSGVO sowie Widerspruch gemäß Art. 21 DSGVO."
  },
  {
   "p": "Soweit eine Verarbeitung auf einer Einwilligung beruht, kann diese jederzeit mit Wirkung für die Zukunft widerrufen werden. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt hiervon unberührt."
  },
  {
   "p": "Zur Ausübung dieser Rechte genügt eine Nachricht an:"
  },
  {
   "p": "info@soulradar.net"
  },
  {
   "h": "28. Widerspruchsrecht"
  },
  {
   "p": "Soweit wir personenbezogene Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO verarbeiten, besteht gemäß Art. 21 DSGVO das Recht, aus Gründen, die sich aus der besonderen Situation der betroffenen Person ergeben, Widerspruch gegen die Verarbeitung einzulegen."
  },
  {
   "p": "Wir verarbeiten die betreffenden personenbezogenen Daten anschließend nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die die Interessen, Rechte und Freiheiten der betroffenen Person überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen."
  },
  {
   "h": "29. Beschwerderecht"
  },
  {
   "p": "Betroffene Personen haben gemäß Art. 77 DSGVO das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren."
  },
  {
   "p": "Für den Verantwortlichen ist insbesondere zuständig:"
  },
  {
   "p": "Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)"
  },
  {
   "p": "Promenade 18"
  },
  {
   "p": "91522 Ansbach"
  },
  {
   "p": "Deutschland"
  },
  {
   "p": "https://www.lda.bayern.de/"
  },
  {
   "p": "Das Recht, sich an eine andere nach der DSGVO zuständige Aufsichtsbehörde zu wenden, bleibt unberührt."
  },
  {
   "h": "30. Automatisierte Entscheidungsfindung"
  },
  {
   "p": "Soul Radar setzt derzeit keine ausschließlich automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO ein, die gegenüber Nutzern rechtliche Wirkung entfaltet oder sie in vergleichbarer Weise erheblich beeinträchtigt."
  },
  {
   "h": "31. Änderungen dieser Datenschutzerklärung"
  },
  {
   "p": "Wir passen diese Datenschutzerklärung an, wenn sich Funktionen von Soul Radar, eingesetzte Dienstleister oder die rechtlichen bzw. technischen Rahmenbedingungen ändern."
  },
  {
   "p": "Es gilt die jeweils auf soulradar.net veröffentlichte aktuelle Fassung."
  }
 ]
};
